export default "__VITE_ASSET__BAIg18kq__"